import { useLocation } from 'react-router-dom';
import { Button, ButtonVariants } from '@components/button/Button';
import { LinkStyledAsButton } from '@components/linkStyledAsButton/LinkStyledAsButton';
import { PageContent } from '../../../layout/PageContent';
import { PageHeader } from '../../../layout/PageHeader';
import { ListingForm } from '../form/ListingForm';
import { CreateListingErrorModal } from './CreateListingErrorModal';
import { CreateListingWarningModal } from './CreateListingWarningModal';
import { useCreateListing } from './useCreateListing';

export const CreateListingPage = () => {
  const { state } = useLocation();
  const {
    closeErrorModal,
    closeWarningModal,
    control,
    errorModalData,
    floorPlans,
    handleOnClickPublish,
    handleOnConfirmSubmit,
    isErrorModalOpen,
    isWarningModalOpen,
    referrer,
    warningModalData,
    setValue,
    resetField,
  } = useCreateListing();

  if (!floorPlans.length) return null;

  return (
    <>
      <PageHeader category="Operations" title="Create Listing">
        <LinkStyledAsButton
          label="Cancel"
          to={referrer}
          variant={ButtonVariants.Tertiary}
        />
        <Button
          label="Publish"
          variant={ButtonVariants.Primary}
          type="button"
          onClick={handleOnClickPublish}
        />
      </PageHeader>
      <PageContent>
        <ListingForm
          control={control}
          setValue={setValue}
          resetField={resetField}
          floorPlans={floorPlans}
          isNewListing={!state.duplicateListingId}
        />
      </PageContent>
      <CreateListingErrorModal
        isOpen={isErrorModalOpen}
        closeModal={closeErrorModal}
        message={errorModalData?.message}
      />
      <CreateListingWarningModal
        isOpen={isWarningModalOpen}
        closeModal={closeWarningModal}
        warnings={warningModalData?.warnings}
        handleOnConfirmSubmit={handleOnConfirmSubmit}
      />
    </>
  );
};
